import styled from "styled-components";
import Footer from "../components/Footer";

const PrivacyPolicy = () => {
  return (
    <>
      <Container>
        <Head>
          <h1>Third Party License</h1>
          <p>Last updated: March 29, 2022</p>
        </Head>
        <Content>
          <p>The following NPM package may be included in this product:</p>
          <p>-@egjs/hammerjs@2.0.17</p>
          <p>This package contains the following license and notice below:</p>
          <p>The MIT License (MIT)</p>
          <p>Copyright (c) 2018-present NAVER Corp.</p>
          <p>
            Permission is hereby granted, free of charge, to any person obtaining a copy of this software and associated
            documentation files (the "Software"), to deal in the Software without restriction, including without
            limitation the rights to use, copy, modify, merge, publish, distribute, sublicense, and/or sell copies of
            the Software, and to permit persons to whom the Software is furnished to do so, subject to the following
            conditions:
          </p>
          <p>
            The above copyright notice and this permission notice shall be included in all copies or substantial
            portions of the Software.
          </p>
          <p>
            THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR IMPLIED, INCLUDING BUT NOT
            LIMITED TO THE WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO
            EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN
            AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE
            OR OTHER DEALINGS IN THE SOFTWARE.
          </p>
          <p>
            Click{" "}
            <a href="/GoTruck_Privacy_Policy.pages" download>
              here
            </a>{" "}
            to and download the full document.
          </p>
        </Content>
      </Container>
      <Footer width={"90%"} />
    </>
  );
};

const Container = styled.div`
  width: 85%;
  min-height: 50vh;
  margin: 0 auto;
  padding: 40px 0;
`;

const Head = styled.div`
  margin-bottom: 40px;
  h1 {
    color: #192d46;
    font-weight: bold;
    font-size: 40px;
    margin: 0;
  }
`;

const Content = styled.div`
  p {
    margin: 0 0 30px 0;
    font-size: 17px;
    color: #667085;
  }

  a {
    color: #e27626;
    text-decoration: underline;
    cursor: pointer;
  }
`;

export default PrivacyPolicy;
